export const getCountryNameFromCodeV3 = (code: number): string => {
  /**   *
   * 00
   * - 00 : Germany (VDE 4105)
   * - 01 : Germany (BDEW)
   * - 02 : Germany (VDE 0126)
   *
   * 01
   * - 00 : Italy (CEI-021 Internal)
   * - 01 : Italy (CEI-016 Italia)
   * - 02 : Italy (CEI-021 External)
   * - 03 : Italy (CEI-021 In Areti)
   *
   * 02
   * - 00 : Australia
   * - 01 : Australia (AU-WA
   * - 02 : Australia (AU-SA)
   *  - 03 : Australia (AU-VIC)
   *  - 04 : Australia (AU-QLD)
   * - 05 : Australia (AU-VAR)
   * - 06 : Australia (AUSGRID)
   * - 07 : Australia (HORIZON)
   *
   * 03
   * - 00 : Spain (RD 1699)
   *
   * 04
   * - 00 : Turkey
   *
   * 05
   * - 00 : Denmark
   * - 01 : Denmark (TR322)
   *
   * 06
   * - 00 : Greece (Continent)
   * - 01 : Greece (Island)
   *
   * 07
   * - 00 : Netherlands
   *
   * 08
   * - 00 : Belgium
   *
   * 09
   * - 00 : United Kingdom (G 99)
   * - 01 : United Kingdom (G 98)
   *
   * 10
   * - 00 : China
   * - 01 : China (Taiwan)
   *
   * 11
   * - 00 : France
   * - 01 : France (FAR Arrete 23)
   *
   * 18
   * - 00 : EU (EN50438)
   * - 01 : EU (EN50549)
   *
   * 19
   * - 00 : IEC EN61727
   *
   * 20
   * - 00 : Korea
   *
   * 21
   * - 00 : Sweden
   *
   * 22
   * - 00 : Europe General
   *
   * 24
   * - 00 : Cyprus
   *
   * 25
   * - 00 : India
   *
   * 26
   * - 00 : Philippines
   *
   * 27
   * - 00 : New Zealand
   *
   * 28
   * - 00 : Brazil
   * - 01 : Brazil (LV)
   * - 02 : Brazil (230)
   * - 03 : Brazil (254)
   *
   * 29
   * - 00 : Slovenia (VSD)
   * - 01 : Slovenia (SSE)
   * - 02 : Slovenia (ZSD)
   *
   * 33
   * - 00 : Ukraine
   *
   * 35
   * - 00 : Mexico (LV)
   *
   * 38
   * - 00 : Wide Range 60hz
   *
   * 39
   * - 00 : Ireland EN50438
   *
   * 40
   * - 00 : Thailand (PEA)
   * - 01 : Thailand (MEA)
   *
   * 42
   * - 00 : LV Range 50hz
   *
   * 44
   * - 00 : South Africa
   *
   * 46
   * - 00 : Dubai (DEWG)
   *  - 01 : Dubai (DEWG MV)
   *
   * 107
   * - 00 : Croatia
   *
   * 108
   * - 00 : Lithuania
   */


  /**
   *   * example: 256 - italy
   * format: 0x0000, bit 8-15: country code (0-255), bit 0-7: region
   */
  // eslint-disable-next-line no-bitwise
  const countryCode = code >> 8;
  // eslint-disable-next-line no-bitwise
  const region = code & 0xff;

  switch (countryCode) {
    case 0:
      switch (region) {
        case 0:
          return 'Germany (VDE 4105)';
        case 1:
          return 'Germany (BDEW)';
        case 2:
          return 'Germany (VDE 0126)';
        default:
          return 'Germany';
      }
    case 1:
      switch (region) {
        case 0:
          return 'Italy (CEI-021 Internal)';
        case 1:
          return 'Italy (CEI-016 Italia)';
        case 2:
          return 'Italy (CEI-021 External)';
        case 3:
          return 'Italy (CEI-021 In Areti)';
        default:
          return 'Italy';
      }
    case 2:
      switch (region) {
        case 1:
          return 'Australia (AU-WA)';
        case 2:
          return 'Australia (AU-SA)';
        case 3:
          return 'Australia (AU-VIC)';
        case 4:
          return 'Australia (AU-QLD)';
        case 5:
          return 'Australia (AU-VAR)';
        case 6:
          return 'Australia (AUSGRID)';
        case 7:
          return 'Australia (HORIZON)';
        default:
          return 'Australia';
      }
    case 3:
      return 'Spain (RD 1699)';
    case 4:
      return 'Turkey';
    case 5:
      switch (region) {
        case 1:
          return 'Denmark (TR322)';
        default:
          return 'Denmark';
      }
    case 6:
      switch (region) {
        case 1:
          return 'Greece (Island)';
        default:
          return 'Greece (Continent)';
      }
    case 7:
      return 'Netherlands';
    case 8:
      return 'Belgium';
    case 9:
      switch (region) {
        case 1:
          return 'United Kingdom (G 98)';
        default:
          return 'United Kingdom (G 99)';
      }
    case 10:
      switch (region) {
        case 1:
          return 'China (Taiwan)';
        default:
          return 'China';
      }
    case 11:
      switch (region) {
        case 1:
          return 'France (FAR Arrete 23)';
        default:
          return 'France';
      }
    case 18:
      switch (region) {
        case 1:
          return 'EU (EN50549)';
        default:
          return 'EU (EN50438)';
      }
    case 19:
      return 'IEC EN61727';
    case 20:
      return 'Korea';
    case 21:
      return 'Sweden';
    case 22:
      return 'Europe General';
    case 24:
      switch (region) {
        case 0:
          return 'Cyprus';
        case 1:
          return 'Cyprus (CY-LV-RES)';
        case 2:
          return 'Cyprus (CY-LN/MV-COM)';
        case 3:
          return 'Cyprus (CY-LV/MV-UT)';
        case 4:
          return 'Cyprus (Reg. 01.2025)';
        default:
          return 'Cyprus';
      }
    case 25:
      return 'India';
    case 26:
      return 'Philippines';
    case 27:
      return 'New Zealand';
    case 28:
      switch (region) {
        case 1:
          return 'Brazil (LV)';
        case 2:
          return 'Brazil (230)';
        case 3:
          return 'Brazil (254)';
        default:
          return 'Brazil';
      }
    case 29:
      switch (region) {
        case 1:
          return 'Slovenia (SSE)';
        case 2:
          return 'Slovenia (ZSD)';
        default:
          return 'Slovenia (VSD)';
      }
    case 33:
      return 'Ukraine';
    case 35:
      return 'Mexico (LV)';
    case 38:
      return 'Wide Range 60hz';
    case 39:
      return 'Ireland EN50438';
    case 40:
      switch (region) {
        case 1:
          return 'Thailand (MEA)';
        default:
          return 'Thailand (PEA)';
      }
    case 42:
      return 'LV Range 50hz';
    case 44:
      return 'South Africa';
    case 46:
      switch (region) {
        case 1:
          return 'Dubai (DEWG MV)';
        default:
          return 'Dubai (DEWG)';
      }
    case 107:
      return 'Croatia';
    case 108:
      return 'Lithuania';
    default:
      return 'Unknown';
  }
};

/**
 * Returns the name of the country for the given code.
 *
 * @param code The country code.
 * @returns The name of the country.
 */
export const getCountryNameFromCodeABC = (code: number): string => {
  switch (code) {
    case 0:
      return 'Germany VDE4105';
    case 1:
      return 'CEI0-21 Internal';
    case 2:
      return 'Australia';
    case 3:
      return 'Spain RD1699';
    case 4:
      return 'Turkey';
    case 5:
      return 'Denmark';
    case 6:
      return 'Greece Continent';
    case 7:
      return 'Netherland';
    case 8:
      return 'Belgium';
    case 9:
      return 'UK-G59';
    case 10:
      return 'China';
    case 11:
      return 'France';
    case 12:
      return 'Poland';
    case 13:
      return 'Germany BDEW';
    case 14:
      return 'Germany VDE0126';
    case 15:
      return 'Italy CEI0-16';
    case 16:
      return 'UK G83';
    case 17:
      return 'Greece island';
    case 18:
      return 'EU EN50438';
    case 19:
      return 'EU EN61727';
    case 20:
      return 'Korea';
    case 21:
      return 'Sweden';
    case 22:
      return 'Europe General';
    case 23:
      return 'CEI0-21 External';
    case 24:
      return 'Cyprus';
    case 25:
      return 'India';
    case 26:
      return 'Philippines';
    case 27:
      return 'NewZealand';
    case 28:
      return 'Reserve';
    case 29:
      return 'Slovakia VSD';
    case 31:
      return 'Slovakia SSE';
    case 32:
      return 'Slovakia ZSD';
    case 33:
      return 'Ukraine';

    case 50:
      return 'VDE4105-MV';
    case 51:
      return 'Italy CEI0-21-MV';
    case 52:
      return 'Australia-MV';
    case 53:
      return 'Spain RD1699-MV';
    case 54:
      return 'Turkey-MV';
    case 55:
      return 'Denmark-MV';
    case 56:
      return 'Greece-MV';
    case 57:
      return 'Netherland-MV';
    case 58:
      return 'Belgium-MV';
    case 59:
      return 'UK-G59-MV';
    case 60:
      return 'China-MV';
    case 61:
      return 'France-MV';
    case 62:
      return 'Poland-MV';
    case 63:
      return 'Germany BDEW-MV';
    case 64:
      return 'Germany VDE0126-MV';
    case 65:
      return 'Italy CEI0-16-MV';
    case 66:
      return 'UK G83-MV';
    case 67:
      return 'Greece island-MV';
    case 68:
      return 'EU EN50438-MV';
    case 69:
      return 'EU EN61727-MV';
    case 70:
      return 'Korea-MV';
    case 71:
      return 'Sweden-MV';
    case 72:
      return 'Europe General-MV';
    case 73:
      return 'Customer-MV';
    case 74:
      return 'Cyprus-MV';
    case 75:
      return 'India-MV';

    default:
      return 'Unknown';
  }
};
